export const SET_DASHBOARDS = 'SET_DASHBOARDS';
export const SET_ERROR = 'SET_ERROR';
export const RESET = 'RESET';
export const SET_SESSION = 'SET_SESSION';
export const SET_SESSION_API_CALL = 'SET_SESSION_API_CALL';
export const SET_DASHBOARD_API_CALL = 'SET_DASHBOARD_API_CALL';
